import React from 'react';

const ThumbsDown = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.5'>
        <path
          d='M9.99935 2H3.99935C3.44602 2 2.97268 2.33333 2.77268 2.81333L0.759349 7.51333C0.699349 7.66667 0.666016 7.82667 0.666016 8V9.33333C0.666016 10.0667 1.26602 10.6667 1.99935 10.6667H6.20602L5.57268 13.7133L5.55268 13.9267C5.55268 14.2 5.66602 14.4533 5.84602 14.6333L6.55268 15.3333L10.946 10.94C11.186 10.7 11.3327 10.3667 11.3327 10V3.33333C11.3327 2.6 10.7327 2 9.99935 2ZM9.99935 10L7.10602 12.8933L7.99935 9.33333H1.99935V8L3.99935 3.33333H9.99935V10ZM12.666 2H15.3327V10H12.666V2Z'
          fill='#FEA82F'
        />
      </g>
    </svg>
  );
};

export default ThumbsDown;
